import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import { CenterFrameLayout } from 'Layouts';
import MVPDPicker from 'Features/SignIn/MVPDPicker';
import { handleMvpdSignIn } from 'Utils/MVPD';
import { signInMvpd } from 'State/User/UserActions';
import { trackPage as segmentTrackPage, SEGMENT_EVENTS } from 'Utils/Analytics/Segment';
import { heapIdentify } from 'Utils/Analytics/Heap';
import { hideOverlay, setHeaderClose } from 'State/Layouts/LayoutActions';
import NotEntitledOverlay from 'Features/SignIn/NotEntitledOverlay/index';
import { signInRedirect } from 'Utils/SignInHelpers';
import './MVPDContainer.css';

export const MVPDContainer = () => {
  const locale = useSelector((s) => s.appConfig.strings);
  const { defaultConfig } = useSelector((s) => s.appConfig);
  const [showNotEntitled, setShowNotEntitled] = useState(false);
  const [selectedMVPD, setSelectedMVPD] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [pageTitleString, setPageTitleString] = useState('Select TV Provider');
  const [redirect, setRedirect] = useState({
    redirectPath: null,
    redirectSearch: null,
    redirectState: {},
    showRedirectLoading: false,
  });
  const { entitlementId } = defaultConfig;
  const location = useLocation();

  const hideNotEntitledOverlay = () => {
    setHeaderClose(null);
    setShowNotEntitled(false);
  };

  const showNotEntitledOverlay = () => {
    setHeaderClose(hideNotEntitledOverlay);
    setShowNotEntitled(true);
    segmentTrackPage(SEGMENT_EVENTS.noAccessLanding, window.location.pathname, 'no_access_landing');
  };

  const onMvpdSignInClick = async (mvpd) => {
    const { mvpdId, name } = mvpd;
    const signInOptions = {
      entitlementId,
      hideOverlay,
      mvpdId,
      mvpdName: name,
    };
    setSelectedMVPD({ selectedMVPD: mvpd });
    setShowLoading(true);
    setPageTitleString('Signing in to your account...');

    const { isEntitled, signInComplete, userData } = await handleMvpdSignIn(signInOptions);

    if (signInComplete) {
      const { profileId } = userData;
      heapIdentify(profileId);
      if (isEntitled) {
        console.debug('redirecting to web-app');
        window.localStorage.removeItem('app_closed');
        signInMvpd(userData);
        const { redirectPath, redirectSearch, redirectState, showRedirectLoading } = await signInRedirect(
          isEntitled,
          location
        );
        setRedirect({
          redirectPath,
          redirectSearch,
          redirectState,
          showRedirectLoading,
        });
      } else {
        setShowLoading(false);
        showNotEntitledOverlay();
      }
    } else {
      setShowLoading(false);
      showNotEntitledOverlay();
    }
  };

  const { redirectPath, redirectSearch, redirectState } = redirect;

  if (redirectPath) {
    return (
      <Navigate
        replace
        to={{
          pathname: redirectPath,
          search: redirectSearch,
        }}
        state={redirectState}
      />
    );
  }

  if (showNotEntitled) {
    return <NotEntitledOverlay selectedMVPD={selectedMVPD} />;
  }

  return (
    <CenterFrameLayout customClass="mvpdTitle" noPanel title={pageTitleString}>
      {!showLoading && (
        <div className="panel mvpd">
          <MVPDPicker withMvpds={locale.withMvpds} onMvpdSignInClick={onMvpdSignInClick}></MVPDPicker>
        </div>
      )}
      {showLoading && <div className="spinnerItem"></div>}
    </CenterFrameLayout>
  );
};
